import { injectGlobal } from 'styled-components';
import theme from 'styles/theme';

/* eslint-disable */
injectGlobal`
  @import 'https://fonts.googleapis.com/css?family=Source+Sans+Pro%3A300italic%2C400italic%2C700italic%2C400%2C300%2C700%7COswald%3A400%2C700%2C300';

  * {
    box-sizing: border-box;
  }

  body, html {
    height: 100%;
  }

  body {
    position: relative;
    margin: 0;
    padding: 0;
    display: flex;
    height: 100vh;
    min-height: 100vh;
    flex-direction: column;
    background: ${theme.B500};
    color: ${theme.font_primary};
    font-family: "Roboto Condensed", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.45;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  a {
    text-decoration: none;
    color: ${theme.A500};
  }

  ::-webkit-scrollbar, ::shadow ::-webkit-scrollbar {
    width: 11px;
    background: transparent;
  }

  ::-webkit-scrollbar-track, ::shadow ::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.8);
  }

  ::-webkit-scrollbar-track:hover, ::shadow ::-webkit-scrollbar-track:hover {
    background-color: rgba(0, 0, 0, 0.81);
  }

  ::-webkit-scrollbar-track:active, ::shadow ::-webkit-scrollbar-track:active {
    background-color: rgba(0, 0, 0, 0.77);
  }

  ::-webkit-scrollbar-thumb, ::shadow ::-webkit-scrollbar-thumb {
    background-color: rgba(20, 172, 208, 0.8);
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb:hover, ::shadow ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(20, 172, 208, 0.85);
  }

  ::-webkit-scrollbar-thumb:active, ::shadow ::-webkit-scrollbar-thumb:active {
    background-color: rgba(20, 172, 208, 0.75);
  }

  .fade-enter,
  .fade-leave {
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .fade-enter {
    opacity: 0.01;
    z-index: 2;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }

  .fade-appear {
    opacity: 0.01;
    z-index: 2;
  }

  .fade-appear.fade-appear-active {
    opacity: 1;
    transition: opacity 300ms;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-leave.fade-leave-active {
    opacity: 0.01;
    transition: opacity 500ms;
  }

  @keyframes rubberBand {
    0% {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }

    30% {
        -webkit-transform: scale3d(1.25, 0.75, 1);
        transform: scale3d(1.25, 0.75, 1);
    }

    40% {
        -webkit-transform: scale3d(0.75, 1.25, 1);
        transform: scale3d(0.75, 1.25, 1);
    }

    50% {
        -webkit-transform: scale3d(1.15, 0.85, 1);
        transform: scale3d(1.15, 0.85, 1);
    }

    65% {
        -webkit-transform: scale3d(0.95, 1.05, 1);
        transform: scale3d(0.95, 1.05, 1);
    }

    75% {
        -webkit-transform: scale3d(1.05, 0.95, 1);
        transform: scale3d(1.05, 0.95, 1);
    }

    100% {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js